import { render, staticRenderFns } from "./VendorMapPoItems.vue?vue&type=template&id=ff67140c&scoped=true&"
import script from "./VendorMapPoItems.vue?vue&type=script&lang=js&"
export * from "./VendorMapPoItems.vue?vue&type=script&lang=js&"
import style0 from "./VendorMapPoItems.vue?vue&type=style&index=0&id=ff67140c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff67140c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
